import React from 'react';

import { DefaultProps } from 'utility-types';

import { styled } from '../theme';
import { Button } from './index';

const StyledButton = styled(Button)<Props>(({ isHidden }) => ({
    overflow: 'hidden',
    position: 'relative',
    maxWidth: 160,
    visibility: isHidden ? 'hidden' : 'visible',
}));

const Input = styled('input')({
    cursor: 'inherit',
    display: 'block',
    fontSize: 999,
    filter: 'alpha(opacity=0)',
    minHeight: '100%',
    minWidth: '100%',
    opacity: 0,
    position: 'absolute',
    right: 0,
    textAlign: 'right',
    top: 0,
});

type Props = {
    label: string;
    accept: string;
    onUploadFile: (event: any) => void;
    inputRef?: any;
    isHidden?: boolean;
};

class UploadFileButton extends React.Component<Props & DefaultProps<typeof UploadFileButton>> {
    static defaultProps = {
        label: '',
        accept: '.csv',
    };

    render() {
        const { label, accept, onUploadFile, inputRef, isHidden } = this.props;

        return (
            <StyledButton isHidden={isHidden}>
                {label}
                <Input ref={inputRef} type="file" accept={accept} onChange={onUploadFile} />
            </StyledButton>
        );
    }
}

export default UploadFileButton;
